import React, { useState, useRef } from 'react'

type RotatingCardProps = {
  children: React.ReactNode | any
  aspectRatio?: string
  maxWidth?: string
  maxHeight?: string
}

const RotatingCard: React.FC<RotatingCardProps> = ({
  children,
  aspectRatio = '3/4',
  maxWidth = '100%',
  maxHeight = '720px',
}) => {
  const [rotation, setRotation] = useState({ x: 0, y: 0 })
  const [isHovering, setIsHovering] = useState(false)
  const cardRef = useRef(null)

  const handleMouseMove = (e: any) => {
    if (!cardRef.current) return

    const rect = (cardRef.current as HTMLElement).getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    const centerX = rect.width / 2
    const centerY = rect.height / 2

    const rotateX = (y - centerY) / 10
    const rotateY = -(x - centerX) / 10

    setRotation({ x: rotateX, y: rotateY })
  }

  const handleMouseEnter = () => {
    setIsHovering(true)
  }

  const handleMouseLeave = () => {
    setIsHovering(false)
    setRotation({ x: 0, y: 0 })
  }

  return (
    <div
      style={{
        width: '100%',
        maxWidth,
        aspectRatio,
        maxHeight,
        perspective: '1000px',
        transformStyle: 'preserve-3d',
        transition: 'transform 0.3s ease',
        transform: isHovering ? 'scale(1.05)' : 'scale(1)',
      }}
    >
      <div
        ref={cardRef}
        onMouseMove={handleMouseMove}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`,
          transition: 'transform 0.1s',
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        {React.Children.map(children, (child) =>
          React.cloneElement(child, {
            style: {
              ...child.props.style,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            },
          })
        )}
      </div>
    </div>
  )
}

export default RotatingCard
